import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-receipt',
  templateUrl: './file-receipt.component.html',
  styles: [
  ]
})
export class FileReceiptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
